const langObject = {
  en: {
    quote: 'js/quotesEN.json',
    wind: 'Wind speed',
    windSpeed: 'm/s',
    humidity: 'Humidity',
    placeholder: '[Enter your name]',
    placeholderCity: '[Enter city]',
    defaultCity: 'Kyiv',
    morning: 'Good morning',
    afternoon: 'Good afternoon',
    evening: 'Good evening',
    night: 'Good night',
    locale: 'en-EN',
    errorNoCity: 'Such city doesn`t exist, try another one',
    errorEmptyInput: 'Empty input. Type a city and try again',
    lastUpdatedText: 'Last updated',
    language: 'Language',
    weather: 'Weather',
    time: 'Time',
    date: 'Date',
    greeting: 'Greeting',
    quote: 'Quote',
    player: 'Player',
    eng: 'Eng',
    ukr: 'Ukr',
    on: 'Show',
    off: 'Hide',
    // widget: 'Widgets',
    // gallery: 'Background image',
    // addBtn: 'Add',
  },
  ua: {
    quote: 'js/quotesUA.json',
    wind: 'Швидкість вітру',
    windSpeed: 'м/с',
    humidity: 'Вологість повітря',
    placeholder: '[Введіть ваше ім`я]',
    placeholderCity: '[Введіть місто]',
    defaultCity: 'Київ',
    morning: 'Доброго ранку',
    afternoon: 'Доброго дня',
    evening: 'Доброго вечора',
    night: 'Доброї ночі',
    locale: 'uk-UA',
    errorNoCity: 'Таке місто не знайдено, спробуйте ще.',
    errorEmptyInput: 'Пустий рядок. Введіть місто.',
    lastUpdatedText: 'Останнє оновлення',
    language: 'Мова',
    weather: 'Погода',
    time: 'Час',
    date: 'Дата',
    greeting: 'Привітання',
    quote: 'Цитата',
    player: 'Аудіо плеєр',
    eng: 'Aнгл',
    ukr: 'Укр',
    on: 'Увімк',
    off: 'Вимк',
    // widget: 'Виджеты',
    // gallery: 'Фоновое изображение',
    // addBtn: 'Добавить',
  },
};

export default langObject;
